import { render, staticRenderFns } from "./GameManagement.vue?vue&type=template&id=94ac81a4&scoped=true"
import script from "./GameManagement.vue?vue&type=script&lang=js"
export * from "./GameManagement.vue?vue&type=script&lang=js"
import style0 from "./GameManagement.vue?vue&type=style&index=0&id=94ac81a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ac81a4",
  null
  
)

export default component.exports